import { styled } from '@mui/material/styles'
import { Box, Container } from '@mui/material'

export const LoginContainer = styled(Box)({
  minHeight: 600,
  height: '100vh',
  display: 'flex',
})

export const BackgroundSection = styled(Box)(({ theme }) => ({
  display: 'none',
  width: '50%',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundImage: 'url("images/auth_bg.jpg")',
  [theme.breakpoints.up('sm')]: {
    display: 'block',
  },
}))

export const FormSection = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  flex: 1,
  [theme.breakpoints.down('sm')]: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
  },
  [theme.breakpoints.down('xs')]: {
    backgroundImage: 'none',
    backgroundColor: '#f3f3f3',
  },
}))

export const CenteredContainer = styled(Container)({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const LoginPanel = styled(Box)(({ theme }) => ({
  margin: '20px 0',
  padding: '30px 60px',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: '#FFFFFF',
  [theme.breakpoints.down('sm')]: {
    padding: '20px',
  },
}))

export const LogoContainer = styled(Box)({
  marginBottom: 48,
  textAlign: 'center',
})

export const TitleContainer = styled(Box)({
  marginBottom: 32,
  textAlign: 'center',
})

export const FormContainer = styled(Box)({
  maxWidth: 400,
})
